import { push } from 'connected-react-router';
import { put } from 'redux-saga/effects';

import ROUTES from 'app/routes/paths';

function* redirectToFormSuccessScreen() {
  yield put(push(ROUTES.external.form.submitted()));
}

export default redirectToFormSuccessScreen;
